module.exports = __webpack_public_path__ + "e86b1aa96d824f8e505d50cb8b3add1e.svg";